<div class="screen-holder" *ngIf="!isUserAuthorized && isCoreInit">
    <div
        class="main-section"
        [style.background-image]="'url(' + (authPageBackground$ | async) + ')'"
    >
        <section class="header-section">
            <serviceos-web-header-screen></serviceos-web-header-screen>
        </section>

        <section class="container content">
            <div class="row">
                <div class="col-12">
                    <div class="modal-holder">
                        <serviceos-web-card>
                            <serviceos-web-recover-password
                                *ngIf="screen === 'recover-password'"
                                (changeScreenEvent)="onChangeScreen($event)"
                            ></serviceos-web-recover-password>
                        </serviceos-web-card>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <section class="footer-section">
        <serviceos-web-footer-screen></serviceos-web-footer-screen>
    </section>
</div>
<serviceos-ng-loader></serviceos-ng-loader>
